import { ApiV1Response, http } from '../http'

// Interface for daily task entity
export interface DailyTaskEntity {
  name: string
  multiplier: number // e.g. 2, Multiplier is a numbe
  type: 'TRADE' | 'SYMBOL' | 'CALLBACK'
  matches: Array<'SPOTS' | 'CONTRACTS' | 'WITHDRAW' | 'CONVERTS' | string> // e.g. '103102', string is symbol id
  period: string // Period represents date as YYYYMMDD format

  // Additional properties by the Frontend
  time: number // e.g. 1630003200000, Timestamp is start of the day
  completed: boolean // e.g. true, Completed is a boolean, defined by the DailyTaskHistory
  history: DailyTaskHistory | null // e.g. null, History is a DailyTaskHistory object
}

export interface DailyTaskHistory {
  id: number
  userId: number
  type: 'TRADE_FARM'
  tradeAmount: number
  multiplier: number
  multiplyTradeAmount: number
  rewardType: 'DAILY'
  createdAt: number // Match with DailyTaskEntity.time to get the task history
}

export interface EarnsDetail {
  detail: null | {
    id: number
    userId: number

    // Trade entities
    rollingNTradeAmount: number // 7-day trade amount
    rollingMTradeAmount: number // 6-day trade amount
    originalWithdrawAmount: number
    originalDepositAmount: number
    originalTradeAmount: number
    multiplyTradeAmount: number

    // Referral entities
    friendsTradeAmount: number
    friendsCount: number
    multiplyFriendsTradeAmount: number
    multiplyTotalAmount: number

    createdAt: number
    updatedAt: number
  }
  // Additional properties
  isV2User: boolean
  isTodayLucky: boolean
  isTomorrowLucky: boolean
  top: number | null // Top is a number, e.g. 10
  multiplier: number

  // Nested activityInfo object
  activityInfo: {
    name: string
    code: string
    startTime: number //
    endTime: number //
    valid: boolean
    momentum: {
      rollingDays: number
      multipliers: { [amount: string]: number } // Use index signature for dynamic amount keys
    }
    task: null // Assuming task is always null
    lucky: {
      multiplier: number
      minAmount: number
    }
    referrals: [number, number, number] // [Convert, Spot, Contract] percentages, e.g. [5, 10, 15]
  }

  // Daily task entities
  dailyTaskEntities: DailyTaskEntity[]

  dailyHistoryList: DailyTaskHistory[]
}

export async function getEarnsDetail<
  T extends ApiV1Response<EarnsDetail>,
>(): Promise<T> {
  return http.get(`/earns/trade/detail`).then((r) => r.data)
}
